import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=5c8cb70e&scoped=true&"
import script from "./FilterMenu.vue?vue&type=script&lang=js&"
export * from "./FilterMenu.vue?vue&type=script&lang=js&"
import style0 from "./FilterMenu.vue?vue&type=style&index=0&id=5c8cb70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cb70e",
  null
  
)

export default component.exports